// extracted by mini-css-extract-plugin
module.exports = {"loader":"PageOverlayLoader_loader__3eAE7","loaderOuter":"PageOverlayLoader_loaderOuter__1K5L9"};